












































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { get } from 'vuex-pathify';
import { capitalize, cloneDeep, isNull, isUndefined, remove } from 'lodash';
import { AxiosError } from 'axios';

// providers
import { authProvider } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';
import { Group } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData';

// utils hhelpers
import mixins, { ExtractVue } from '@/utils/mixins';

// mixins
import componentState from '@/mixins/state';
import formRules from '@/mixins/file-upload-rules';
import snackbar from '@/mixins/snackbar';

// helpers
import { deepEqual, scrollToBottomOfHtmlElement } from '@/utils/helpers';

// models
import {
  QuoteProductItem,
  Quote,
  QuoteType,
  QuoteAirwayVentilationSubType,
  QuoteProductCategory,
  QuoteFieldError,
  QuoteAddress,
  IQuoteAddress,
  QuoteVentilationRoom,
  IQuoteVentilationRoom,
  QuoteVentilationCapacity,
  QuoteOrganization,
  IQuoteOrganization,
  QuoteState,
  QuotePaymentTermItem,
  IQuotePaymentTermItem
} from '@/models/quote';

import { Customer, ICustomer, ICustomerAddress } from '@/models/customer';
import { Currency, CurrencyRate, ICurrency } from '@/models/currency';

import { ErrorManager } from '@/models/error';
import { IQuote, IQuoteProductItem } from '@/models';

// compnents utils
import { ALForm } from '@/common/component.types';

// components
import DragDropFileInput from '../common/DragDropFileInput.vue';
import ButtonFileInput from '../common/ButtonFileInput.vue';
import TextSelectField from '../common/TextSelectField.vue';
import QuoteVentilationRoomCard from './QuoteVentilationRoomCard.vue';
import RegionPicker from '../region/RegionPicker.vue';
import CountryPicker from '../common/CountryPicker.vue';
import QuillPDFEditor from '../common/QuillPDFEditor.vue';
import { Module } from '@/models/configurator/module';
import { requiredValidator } from '@/utils/validators';
import { getCountryByCountryName } from '@/data/countries';

/**
 * @summary When updating STEPS update {FirstStep} if other enum is made 1
 * @enum STEPS
 */
enum STEPS {
  QuoteOrganization = 1,
  QuoteType = 2,
  QuoteHeader = 3,
  QuoteMachine = 4
}

const FirstStep = STEPS.QuoteOrganization;

const baseMixins = mixins(formRules, componentState, snackbar);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    quoteOrganization: ALForm;
    quoteType: ALForm;
    quoteHeader: ALForm;
    quoteMachine: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'QuoteServiceFormDialog',

    components: {
      DragDropFileInput,
      ButtonFileInput,
      TextSelectField,
      QuoteVentilationRoomCard,
      RegionPicker,
      CountryPicker,
      QuillPDFEditor
    },

    data: () => ({
      valid: false,
      wizardDialog: false,
      actionOnLeave: false,
      step: FirstStep,
      STEPS,

      QuoteType,

      quoteTypeRules: [
        (v: any) => !isUndefined(v) || 'You must choose one to continue!'
      ],

      quoteHeaderRules: [
        (v: any) => !!v || 'This field is required',
        (v: any) => !isNull(v) || 'This field is required!'
      ],

      quoteMachineRules: [
        (v: any) => true // allow no (zero) modules being added to quote (requested by client)
      ],

      quoteConfigurationRules: [
        (v: any) => true || 'A module must be selected'
      ],

      // forms
      headerValidForm: true,
      organizationStepValidForm: true,
      typeValidForm: true,
      uploadValidForm: true,
      configurationValidForm: true,

      quoteSetup: new Quote(),
      originalQuoteSetup: new Quote(),
      createForm: true,
      routeToQuoteDetailOnSave: true,

      currencyCode: 'CAD',

      errorMessage: '',
      detailErrorMessage: '',
      showDetailError: false,
      dateMenu: false,
      fieldError: new QuoteFieldError(),

      file_upload: null as File | null,
      ventilationLoading: false,
      formLoading: false,

      phaseTypes: [
        '200V/3PH/50 Hz',
        '208V/3PH/50 Hz',
        '230V/3PH/50 Hz',
        '380V/3PH/50 Hz',
        '400V/3PH/50 Hz',
        '440V/3PH/50 Hz',
        '460V/3PH/50 Hz',
        '575V/3PH/50 Hz',
        '200V/3PH/60 Hz',
        '208V/3PH/60 Hz',
        '230V/3PH/60 Hz',
        '380V/3PH/60 Hz',
        '400V/3PH/60 Hz',
        '440V/3PH/60 Hz',
        '460V/3PH/60 Hz',
        '480V/3PH/60 Hz',
        '575V/3PH/60 Hz'
      ],

      boilerTypes: ['Natural Gas', 'LPG', 'Diesel', 'Propane', 'Electric'],

      editorOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'link'],
            [{ list: 'ordered' }, { list: 'bullet' }]
          ]
        }
      },

      successUploadMessage: '',

      displayCapacitiesAndConditions: false
    }),

    computed: {
      authProvider(): any {
        return authProvider(this.$store);
      },

      ...mapGetters({
        getQuoteById: 'quote/getQuoteById',
        getQuoteLastAdded: 'quote/getQuoteLastAdded',
        getModuleById: 'configuratorModule/getModuleById',
        getQuotePaymentTermTemplateByCode:
          'quoteTemplate/getQuotePaymentTermTemplateByCode'
      }),

      exchangeRates: get<CurrencyRate[]>('currency/getCurrencies'),

      getCustomerById: get<(id: string) => Customer>(
        'customer/getCustomerById'
      ),

      quoteVentilationAirwaySubTypes() {
        return [
          {
            text: 'CC3',
            value: QuoteAirwayVentilationSubType.CC3
          },
          {
            text: 'Modular',
            value: QuoteAirwayVentilationSubType.MODULAR
          },
          {
            text: 'Art',
            value: QuoteAirwayVentilationSubType.ART
          }
        ];
      },

      quoteOrganizationTypes(): IQuoteOrganization[] {
        return QuoteOrganization.getOrganizationList();
      },

      quoteTypes() {
        const base = [
          {
            text: 'After Market Parts',
            value: QuoteType.AFTER_MARKET_PARTS
          }
        ];

        const userGroups: Group[] =
          this.authProvider.getCurrentUser.groups ?? [];

        const eligible = userGroups.find(
          ({ name }) => name === 'Order Management'
        );

        if (eligible || this.authProvider.isUserAdmin) {
          base.unshift({
            text: 'Machine Projects',
            value: QuoteType.MACHINE_PROJECTS
          });
          base.push({
            text: 'RTU Ventilation',
            value: QuoteType.RTU_VENTILATION
          });
          base.push({
            text: 'Airway Ventilation',
            value: QuoteType.AIRWAY_VENTILATION
          });
          base.push({
            text: 'Automation',
            value: QuoteType.AUTOMATION
          });
        }

        return base;
      },

      quoteVentilationRules() {
        return [(v: File) => !!v || 'Must add RTU file'];
      },

      currentTitle(): string {
        switch (this.step) {
          case STEPS.QuoteOrganization:
            return 'Organization';

          case STEPS.QuoteType:
            return 'Quote Type';

          case STEPS.QuoteHeader:
            return 'Quote Header Information';

          case STEPS.QuoteMachine:
            return `${capitalize(this.quoteWizardModuleSelectorTitle)} Parts`;

          default:
            return 'Default Title';
        }
      },

      quoteWizardModuleSelectorTitle(): string {
        switch (this.quoteSetup.type) {
          case QuoteType.AFTER_MARKET_PARTS:
            return 'after market';

          case QuoteType.RTU_VENTILATION:
            return 'RTU ventilation';

          case QuoteType.AIRWAY_VENTILATION:
            return 'airway ventilation';

          case QuoteType.AUTOMATION:
            return 'automation';

          case QuoteType.MACHINE_PROJECTS:
          default:
            return 'machine';
        }
      },

      allQuoteProducts(): IQuoteProductItem[] {
        return this.quoteSetup.getAllProducts();
      },

      isQuoteVentilationRTU(): boolean {
        return this.quoteSetup.type == QuoteType.RTU_VENTILATION;
      },
      isQuoteVentilationAirway(): boolean {
        return this.quoteSetup.type == QuoteType.AIRWAY_VENTILATION;
      },

      isQuoteVentilation(): boolean {
        return this.isQuoteVentilationRTU || this.isQuoteVentilationAirway;
      },

      isAfterMarketParts(): boolean {
        return this.quoteSetup.type == QuoteType.AFTER_MARKET_PARTS;
      },

      quoteCustomerPricingSnapshot(): number | undefined {
        return this.quoteSetup.customer?.contract?.snapshot;
      },

      errorOccurred(): boolean {
        return this.errorMessage.length > 0;
      },
      detailErrorOccurred(): boolean {
        return this.detailErrorMessage.length > 0;
      },

      quoteSetupCustomerShippingAddresses(): ICustomerAddress[] {
        let addresses: ICustomerAddress[] = [];

        if (this.quoteSetup.customer) {
          const customer = this.getCustomerById(
            this.quoteSetup.customer.identifier!
          );
          if (customer) {
            addresses = customer.shipping_addresses;
          }
        }

        return addresses;
      }
    },

    mounted() {
      try {
        this.fetchModules();
        // To avoid issue of not having the payment term when selecting customer with term
        this.fetchQuotePaymentTermTemplates();
      } catch (error) {
        this.errorMessage = ErrorManager.extractApiError(error as AxiosError);
      }
    },

    methods: {
      requiredValidator,

      ...mapActions('configuratorModule', ['fetchModules']),
      ...mapActions('quote', [
        'createQuote',
        'updateQuote',
        'importQuoteVentilationXls'
      ]),
      ...mapActions('customer', ['fetchCustomer']),

      ...mapActions({
        fetchQuotePaymentTermTemplates:
          'quoteTemplate/fetchQuotePaymentTermTemplates'
      }),

      toggleDetailError() {
        this.showDetailError = !this.showDetailError;
      },

      clearCustomer() {
        this.$nextTick(() => {
          this.quoteSetup.customer!.identifier = '';
          this.quoteSetup.customer!.name = '';
          this.quoteSetup.customer.is_same_billing_address = true;

          // clear previously set company address
          this.quoteSetup.customer.address = new QuoteAddress();
          // clear previously set billing address
          this.quoteSetup.customer!.ship_to_name = '';
          this.quoteSetup.customer!.ship_address! = new QuoteAddress();
        });
      },

      clearAllErrors(): void {
        this.errorMessage = '';
        this.detailErrorMessage = '';
        this.showDetailError = false;
        this.fieldError.clearErrors();
      },

      addProductItem(product: QuoteProductItem) {
        const quoteProductCategory = this.quoteSetup.categories.find(
          ({ module }) => module == product.module
        );

        if (quoteProductCategory) {
          quoteProductCategory.products?.push(product);
        } else {
          const configuratorModule: Module = this.getModuleById(product.module);

          const category = new QuoteProductCategory({
            module: product.module!,
            // if module is subscription then set the first year subscription to 100%
            first_year_subscription_discount_percentage: configuratorModule.is_subscription
              ? 100
              : 0
          });
          category.products?.push(product);

          // no need to add since product is a constructor parameter
          this.quoteSetup.categories.push(category);
        }
      },

      updateProductItem(product: IQuoteProductItem) {
        // Assigning object to a product item instance to get access to method
        const quoteProductCategory = this.quoteSetup.categories.find(
          ({ module }) => module == product.module
        );

        let isOperationSuccess = false;

        if (quoteProductCategory) {
          const index = quoteProductCategory.products?.findIndex(productItem =>
            product.isEqual(productItem)
          );

          if (index !== null && index !== undefined) {
            quoteProductCategory.products?.splice(index, 1, product);
            isOperationSuccess = true;
          }
        }
        if (!isOperationSuccess) {
          this.createSnack({
            color: 'error',
            type: 'error',
            right: true,
            useBtn: false,
            msg: 'Unable to update product. Contact admin for assistance',
            timeout: 6000
          });
        }
      },

      removeProductItem(product: IQuoteProductItem) {
        const quoteProductCategory = this.quoteSetup.categories.find(
          ({ module }) => module == product.module
        );
        let isOperationSuccess = false;

        if (quoteProductCategory) {
          // every category will have a product field whether empty or not
          const productIndex = quoteProductCategory.products!.indexOf(product);

          if (productIndex > -1) {
            quoteProductCategory.products?.splice(productIndex, 1);
            isOperationSuccess = true;
          }
        }

        if (!isOperationSuccess) {
          this.createSnack({
            color: 'error',
            type: 'error',
            right: true,
            useBtn: false,
            msg: 'Unable to delete product. Contact admin for assistance',
            timeout: 6000
          });
        }
      },

      async addQuoteVentilationRoom(description = '') {
        const room = new QuoteVentilationRoom({
          quote: this.quoteSetup.number!,
          description: description
        });

        this.quoteSetup.addVentilationRoom(room);

        return scrollToBottomOfHtmlElement('#scrollable-card');
      },

      removeQuoteVentilationRoom(room: IQuoteVentilationRoom) {
        if (room.id) {
          this.quoteSetup.removeVentilationRoom(room);
        } else {
          const index = this.quoteSetup.rooms.findIndex(
            ventilationRoom => ventilationRoom == room
          );

          if (index != -1) {
            this.quoteSetup.rooms.splice(index, 1);
          }
        }
      },

      moveToFirstStep() {
        this.step = FirstStep;
      },

      moveToQuoteOrganizationStep() {
        this.step = STEPS.QuoteOrganization;
      },

      movetoQuoteType() {
        this.step = STEPS.QuoteType;
      },

      movetoQuoteHeader() {
        this.step = STEPS.QuoteHeader;
      },

      movetoQuoteMachine() {
        this.step = STEPS.QuoteMachine;
      },

      selectCustomerShippingAddress(quoteAddress?: IQuoteAddress) {
        this.quoteSetup.customer.ship_address = quoteAddress;

        if (quoteAddress && quoteAddress.country) {
          const quoteAddressCountry = getCountryByCountryName(
            quoteAddress.country
          );

          if (quoteAddressCountry) {
            this.quoteSetup.customer.ship_address!.country_code =
              quoteAddressCountry.code;
          } else {
            this.quoteSetup.customer.ship_address!.country_code = '';
          }
        }
      },

      async saveAndMoveToQuoteMachine() {
        if (this.quoteSetup.customer?.identifier) {
          const selectedCustomer = this.getCustomerById(
            this.quoteSetup.customer.identifier
          );

          this.quoteSetup.customer.name = selectedCustomer.name;
          this.quoteSetup.customer.address!.address1 =
            selectedCustomer.address1;
          this.quoteSetup.customer.address!.address2 =
            selectedCustomer.address2;
          this.quoteSetup.customer.address!.address3 =
            selectedCustomer.address3;
          this.quoteSetup.customer.address!.address4 =
            selectedCustomer.address4;
          this.quoteSetup.customer.address!.city = selectedCustomer.city;
          this.quoteSetup.customer.address!.region = selectedCustomer.region;
          this.quoteSetup.customer.address!.postal_code =
            selectedCustomer.postal_code;

          const customerCountry = getCountryByCountryName(
            selectedCustomer.country
          );
          if (customerCountry) {
            this.quoteSetup.customer.address!.country = customerCountry.name;

            this.quoteSetup.customer.address!.country_code =
              customerCountry.code;
          } else {
            this.quoteSetup.customer.address!.country = '';
            this.quoteSetup.customer.address!.country_code = '';
          }
        } else if (this.quoteSetup.customer?.is_same_billing_address) {
          this.quoteSetup.customer!.ship_to_name = this.quoteSetup.customer!.name;
          const shipAddressId = this.quoteSetup.customer.ship_address!.id;

          // cache shipping_address id to not orphan previous shipping address when saving quote customer object
          this.quoteSetup.customer!.ship_address = new QuoteAddress({
            ...this.quoteSetup.customer!.address,
            id: shipAddressId
          });
        }
        try {
          if (this.validateForms()) {
            this.formLoading = true;
            this.clearAllErrors();
            if (this.createForm) {
              const quote = cloneDeep(this.quoteSetup);
              if (!this.isQuoteVentilation) {
                // also set the switch to false
                this.displayCapacitiesAndConditions = false;
                quote.capacity = null;
              }
              await this.createQuote(quote).then(() => {
                const quote: Quote = this.getQuoteLastAdded;
                this.originalQuoteSetup = cloneDeep(quote);
                this.quoteSetup = cloneDeep(quote);

                this.setComponentState('loaded');

                this.createForm = false;

                this.movetoQuoteMachine();
              });
            } else {
              const quote = this.parseQuoteDataForEdit(this.quoteSetup);
              // If quote is a ventilation type then create a capaicity else remove it from the data sent
              if (!this.isQuoteVentilation) {
                // also set the switch to false
                this.displayCapacitiesAndConditions = false;
                quote.capacity = null;
              }

              await this.updateQuote(quote).then(() => {
                const quote: Quote = this.getQuoteById(this.quoteSetup.number);
                this.originalQuoteSetup = cloneDeep(quote);
                this.quoteSetup = cloneDeep(quote);

                this.$emit('updated:quote', quote);
                this.setComponentState('loaded');

                this.movetoQuoteMachine();
                return quote;
              });
            }
          } else {
            this.setComponentState('loaded');
          }
        } catch (err) {
          const error = err as AxiosError;
          if (error.response) {
            // client received an error response that falls out of range 2xx
            if (QuoteFieldError.isQuoteFieldError(error.response.data)) {
              this.fieldError = new QuoteFieldError(error.response.data);
            }
          }

          this.errorMessage = ErrorManager.extractApiError(error);
        } finally {
          this.formLoading = false;
        }
      },

      parseQuoteDataForEdit(quote: Quote) {
        // TODO: Check for any other fields that are serialized as string
        // ?For fields that are serialized as strings but need the id to be passed to the api
        const quoteClone = cloneDeep(quote);
        if (typeof quoteClone.agent === 'string') {
          delete quoteClone.agent;
        }
        if (typeof quoteClone.inside_sales_owner === 'string') {
          delete quoteClone.inside_sales_owner;
        }

        // remove all categories with no products
        // remove mutates array
        remove(
          quoteClone.categories,
          category => category.products && category.products.length == 0
        );

        return quoteClone;
      },

      closeQuoteWizardForm() {
        const quote: Quote = this.getQuoteById(this.quoteSetup.number);

        return this.close().then(() => this.$emit('updated:quote', quote));
      },

      importQuoteVentilationXlsFileHandler() {
        this.clearAllErrors();
        this.successUploadMessage = '';
        this.ventilationLoading = true;
        this.importQuoteVentilationXls({
          quoteId: this.quoteSetup.number,
          file: this.file_upload
        })
          .then(() => {
            const quote: Quote = this.getQuoteById(this.quoteSetup.number);
            this.originalQuoteSetup = cloneDeep(quote);
            this.quoteSetup = cloneDeep(quote);
            this.$nextTick(() => {
              this.successUploadMessage = 'File successfully uploaded';
            });
          })
          .catch(error => {
            if (error.response) {
              // client received an error response that falls out of range 2xx
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }

            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.ventilationLoading = false;
          });
      },

      async saveAndMoveToQuoteDetail() {
        this.clearAllErrors();
        this.formLoading = true;
        try {
          if (this.routeToQuoteDetailOnSave) {
            // in the case where we created this quote then we update the current quote configurations
            // TODO: - LH - 2021-10-15 - Look into making the actions after this api call on the parent components instead
            await this.updateQuote(this.parseQuoteDataForEdit(this.quoteSetup));
            const quote: Quote = this.getQuoteLastAdded;
            this.originalQuoteSetup = cloneDeep(quote);
            this.quoteSetup = cloneDeep(quote);
            this.close().then(() =>
              this.$router.push({
                name: 'quote-revision-detail',
                params: {
                  quoteId: String(quote.number),
                  quoteRevision: String(quote.revision)
                }
              })
            );
          } else {
            await this.updateQuote(this.parseQuoteDataForEdit(this.quoteSetup));
            const quote: Quote = this.getQuoteById(this.quoteSetup.number);
            this.originalQuoteSetup = cloneDeep(quote);
            this.quoteSetup = cloneDeep(quote);
            this.close().then(() => this.$emit('updated:quote', quote));
          }
        } catch (err) {
          const error = err as AxiosError;
          if (error.response) {
            // client received an error response that falls out of range 2xx
            if (QuoteFieldError.isQuoteFieldError(error.response.data)) {
              this.fieldError = new QuoteFieldError(error.response.data);
            }

            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        } finally {
          this.formLoading = false;
        }
      },

      currencyUpdated(currencyId: number) {
        const exchangeRate = this.exchangeRates.find(
          rate => (rate.currency as Currency)?.id === currencyId
        );

        if (exchangeRate) {
          this.quoteSetup.exchange_rate = exchangeRate.rate;
          this.currencyCode = (exchangeRate.currency as Currency)!.code!;
        }
      },

      shippingInfoUpdated(info: any) {
        this.quoteSetup.customer.is_same_billing_address = false;
        this.quoteSetup.customer.ship_to_name = info.name;
      },

      customerUpdated(customer?: ICustomer) {
        // in the event on a null customer we set the currency value to default(CAD)
        const currencyCode = customer?.currency ?? 'CAD';

        // find currency that matches code and set the id of that currency
        const exchangeRate = this.exchangeRates.find(
          rate => currencyCode === (rate.currency as Currency)?.code
        );
        if (exchangeRate) {
          const currency = exchangeRate.currency as ICurrency;

          this.quoteSetup.currency = currency.id;
          this.currencyCode = currency.code;
          this.quoteSetup.exchange_rate = exchangeRate.rate;
        }

        if (customer) {
          // set tax id
          this.quoteSetup.customer.tax_id = customer.tax_id;

          if (customer.terms) {
            // set the payment term based on customer
            const paymentTermTemplate = this.getQuotePaymentTermTemplateByCode(
              customer.terms
            );

            // only if a code has been assigned to a template it will be found
            if (paymentTermTemplate) {
              // TODO: 2023-08-21 - LH - add order to quote payment term item
              const paymentTermItem = new QuotePaymentTermItem({
                template: paymentTermTemplate.id,
                title: paymentTermTemplate.title,
                description: paymentTermTemplate.description
              });

              this.quoteSetup.payment_terms.splice(
                0,
                this.quoteSetup.payment_terms.length
              );
              this.quoteSetup.payment_terms.push(paymentTermItem);
            }
          }
        }
      },

      momentFormat(date: Date | string | number, days = 0) {
        return moment(date ?? new Date())
          .add(days, 'd')
          .format('LL')
          .toString();
      },

      allowedDates: (val: string) => {
        return moment(val).isSameOrBefore(new Date(), 'day');
      },

      formatDate(date: string): string {
        return date ? moment(date).format('MMMM D YYYY') : '';
      },

      /**
       * @public
       *
       * Opens QuoteWizardFormDialog to create quote
       */
      open(quote?: IQuote) {
        this.wizardDialog = true;

        // using clonedeep to not assign by reference
        this.quoteSetup = cloneDeep(Object.assign(new Quote(), quote));
        this.originalQuoteSetup = cloneDeep(this.quoteSetup);
        this.createForm = !quote ? true : false;
        this.routeToQuoteDetailOnSave = this.createForm;
        if (!this.createForm) {
          if (this.quoteSetup.state == QuoteState.DRAFT) {
            this.moveToFirstStep();
          } else {
            this.movetoQuoteMachine();
          }
        }
        // clear success message on open dialog
        this.successUploadMessage = '';

        if (this.quoteSetup.capacity) {
          this.displayCapacitiesAndConditions = true;
        }

        if (this.quoteSetup.customer.identifier) {
          this.tryGetOrFetchCustomer(this.quoteSetup.customer.identifier);
        }
      },

      tryGetOrFetchCustomer(identifier: string) {
        const customer = this.getCustomerById(identifier);
        if (!customer) {
          this.clearAllErrors();
          this.fetchCustomer(identifier).catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          });
        }
      },

      updateDisplayCapacitiesAndConditions(display: boolean) {
        if (!display) {
          this.quoteSetup.capacity = null;
        } else {
          if (!this.quoteSetup.capacity) {
            this.quoteSetup.capacity = new QuoteVentilationCapacity();
          }
        }
      },

      validateForms() {
        if (this.wizardDialog) {
          const quoteOrganization = this.$refs.quoteOrganization;
          if (quoteOrganization) {
            if (!quoteOrganization.validate()) {
              this.moveToQuoteOrganizationStep();

              return false;
            }
          }

          const quoteType = this.$refs.quoteType;
          if (quoteType) {
            if (!quoteType.validate()) {
              this.movetoQuoteType();

              return false;
            }
          }

          const quoteHeader = this.$refs.quoteHeader;
          if (quoteHeader) {
            if (!quoteHeader.validate()) {
              this.movetoQuoteHeader();
              return false;
            }
          }

          return true;
        }
      },

      resetValidationForms() {
        if (this.wizardDialog) {
          const quoteMachine = this.$refs.quoteMachine;

          if (quoteMachine) quoteMachine.resetValidation();
          const quoteHeader = this.$refs.quoteHeader;
          if (quoteHeader) quoteHeader.resetValidation();
          const quoteType = this.$refs.quoteType;
          if (quoteType) quoteType.resetValidation();
          const quoteOrganization = this.$refs.quoteOrganization;
          if (quoteOrganization) quoteOrganization.resetValidation();
        }
      },

      resetComponentData() {
        this.moveToFirstStep();
        this.quoteSetup = new Quote();
        this.actionOnLeave = false;
        this.wizardDialog = false;
        this.displayCapacitiesAndConditions = false;
      },

      async close() {
        // if quote is not the same then open confirm
        if (!deepEqual(this.originalQuoteSetup, this.quoteSetup)) {
          await this.confirmDiscard().then((result: boolean) => {
            this.resetValidationForms();

            if (result) {
              this.$nextTick(() => {
                this.resetComponentData();
              });
            }
          });
        } else {
          await this.$nextTick(() => {
            this.resetValidationForms();
            this.resetComponentData();
          });
        }
      },

      async confirmDiscard() {
        const { default: confirmComponent } = await import(
          '@/components/core/ConfirmDialog.vue'
        );

        if (confirmComponent) {
          const confirmDialog = this.$refs.confirm as ExtractVue<
            typeof confirmComponent
          >;
          return await confirmDialog.open(
            'Discard changes?',
            {
              right: {
                text: 'Yes'
              }
            },
            'This cannot be undone'
          );
        } else {
          // If we cant get the confirm dialog,
          //  if error comes up just return true
          return Promise.resolve(true);
        }
      },

      onPhoneNumberInput(
        fromattedNumber: string,
        { number }: { number: { international: string } }
      ) {
        this.quoteSetup.customer!.contact!.phone = number.international ?? "";
        this.clearAllErrors();
      },

      parseNullableFloatValue(value: string) {
        // vue templates do not allow null coalesing so its better to apply it within the constructed class
        return parseFloat(value) ?? null;
      }
    }
  });
